import { Link } from 'react-router-dom';

import { usePlayer } from '../../stores/player';
import { useMyJam } from './useJam';

/**
 * A small mark in the player bar while in a jam: lit when the queue is the
 * jam's, quiet when it is not, and a link to the jam either way. Nothing
 * when there is no jam, which is nearly always. At every width: on a phone
 * this is the only thing that says "you are in a jam" outside the jam page.
 */
export function JamChip() {
  const { data } = useMyJam();
  const source = usePlayer((state) => state.source);
  const jam = data?.jam ?? null;

  if (jam === null) return null;

  const live = source === 'jam';

  return (
    <Link
      to={`/jam/${jam.code}`}
      title={live ? 'Playing from the jam' : 'You are in a jam'}
      data-jam-chip={live ? 'playing' : 'idle'}
      className={`flex shrink-0 items-center gap-1.5 rounded-[var(--radius-pill)] border px-2.5 py-1 font-mono text-[10px] uppercase tracking-wide transition-colors ${
        live
          ? 'border-fresh-edge bg-fresh-wash text-fresh'
          : 'border-line text-faint hover:border-line-lit hover:text-ink'
      }`}
    >
      <span aria-hidden className={`h-1.5 w-1.5 rounded-full ${live ? 'bg-fresh' : 'bg-line-strong'}`} />
      jam<span className="hidden sm:inline"> · {jam.members.length}</span>
    </Link>
  );
}
